function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'white-sand-pearl': 'rgb(231, 230, 221)','unpainted': 'rgb(16, 16, 16)','vivid-black': 'rgb(1, 1, 1)','billiard-grey': 'rgb(169, 169, 169)','barracuda-silver': 'rgb(116, 124, 128)','gunship-grey': 'rgb(89, 97, 104)','billiard-red': 'rgb(172, 0, 6)','billiard-blue': 'rgb(36, 44, 50)','brilliant-red': 'rgb(239, 76, 44)','stone-washed-white-pearl': 'rgb(235, 223, 198)','sharkskin-blue': 'rgb(154, 180, 193)','blue-burst': 'rgb(26, 58, 107)','white-onyx-pearl': 'rgb(240, 237, 232)','midnight-crimson': 'rgb(107, 0, 16)','dark-billiard-gray': 'rgb(74, 74, 74)','red-rock': 'rgb(139, 58, 42)','olive-steel-metallic': 'rgb(107, 115, 85)','iron-horse-metallic': 'rgb(90, 79, 69)','mystic-shift': 'rgb(74, 58, 107)','blood-orange': 'rgb(204, 51, 0)','aurora-blue-denim': 'rgb(58, 95, 138)','wicked-red': 'rgb(204, 0, 34)','midnight-blue': 'rgb(10, 22, 40)','twisted-cherry': 'rgb(139, 26, 42)','electric-blue': 'rgb(0, 68, 204)',};

    this.images = {};

    this.triggers = ['color','colour','couleur','farbe','cor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
